import React from 'react';
import { Monitor, Video, Users, ArrowRight } from 'lucide-react';
import { Card } from './ui/Card';
const formats = [{
  title: 'Online Classes',
  description: 'Self-paced courses you can take anytime, anywhere. Perfect for busy schedules.',
  icon: Monitor,
  color: 'text-blue-600',
  bgColor: 'bg-blue-50',
  cta: 'Browse Online Classes'
}, {
  title: 'Zoom Classes',
  description: 'Live interactive instruction from your home or office. Real-time engagement with instructors.',
  icon: Video,
  color: 'text-brand-purple-600',
  bgColor: 'bg-brand-purple-50',
  cta: 'View Zoom Schedule'
}, {
  title: 'Live Classes',
  description: 'Traditional classroom setting for hands-on learning and networking with other agents.',
  icon: Users,
  color: 'text-brand-orange-600',
  bgColor: 'bg-brand-orange-50',
  cta: 'Find a Location'
}];
export function ClassFormats() {
  return <section className="py-20 bg-gray-50" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-4">
            Choose Your Learning Style
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-5">
            We offer flexible formats to meet your Arizona real estate license
            renewal requirements.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6">
          {formats.map((format, index) => <Card key={index} hoverEffect className="flex flex-col h-full p-8" data-id="element-7">
              <div className={`w-14 h-14 rounded-xl ${format.bgColor} ${format.color} flex items-center justify-center mb-6`} data-id="element-8">
                <format.icon className="w-7 h-7" data-id="element-9" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-10">
                {format.title}
              </h3>
              <p className="text-gray-600 mb-8 flex-grow leading-relaxed" data-id="element-11">
                {format.description}
              </p>
              <div className="mt-auto" data-id="element-12">
                <a href="#" className={`inline-flex items-center font-semibold ${format.color} hover:underline`} data-id="element-13">
                  {format.cta} <ArrowRight className="ml-2 w-4 h-4" data-id="element-14" />
                </a>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}